import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeWrapper, PAYPAL_THEME } from '@paypalcorp/pp-react';
import loadable from '@loadable/component';
import { AppContextProvider } from '@client/contexts/AppContext';
import Notfound from '@components/notfound';
import { ErrorPageVariant, type Onboarding } from '@components/ErrorPage';
import '@client/lib/datadog';

// TODO: remove this after pp-react upgrade complete
const LoadablePayment = loadable(() => import('@components/payment'), {
  ssr: false
});

const ErrorPage = loadable(() => import('@components/ErrorPage'), {
  ssr: false
});

function App({ initialAppData }) {
  return (
    <ThemeWrapper theme={PAYPAL_THEME}>
      <AppContextProvider value={initialAppData}>
        <Routes>
          <Route path="/payment/:hostedButtonId" element={<LoadablePayment />} />
          <Route path="/notfound" element={<Notfound />} />
          <Route
            path="/account-restricted"
            element={
              <ErrorPage
                variant={ErrorPageVariant.AccountRestricted}
                onboarding={initialAppData.onboarding as Onboarding | undefined}
              />
            }
          />
        </Routes>
      </AppContextProvider>
    </ThemeWrapper>
  );
}

export default App;
